"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./Divider.scss");

var _excluded = ["text", "hidden", "skin", "spacing", "textAlign", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Optional text that indicates what comes after the divider */
  text: _propTypes.string,

  /** A hidden divider separates content with space only. No visible line */
  hidden: _propTypes.bool,

  /** Align the text in the divider */
  textAlign: (0, _propTypes.oneOf)(['left', 'center', 'right']),

  /** The amount of space above and below it */
  spacing: (0, _propTypes.oneOf)(['none', 'xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl']),

  /** Divider color */
  skin: (0, _propTypes.oneOf)(['light', 'dark']),

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  spacing: 'm',
  textAlign: 'center',
  skin: 'dark'
};
/**
 * The Divider can separate and group content to create clear groups. It can also display a short text to indicate what comes after the divider.
 */

var Divider = function Divider(_ref) {
  var text = _ref.text,
      hidden = _ref.hidden,
      skin = _ref.skin,
      spacing = _ref.spacing,
      textAlign = _ref.textAlign,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-divider', {
    'rds-divider--has-text': text,
    'rds-is-invisible': hidden,
    'rds-my--none': spacing === 'none',
    'rds-my--xxxs': spacing === 'xxxs',
    'rds-my--xxs': spacing === 'xxs',
    'rds-my--xs': spacing === 'xs',
    'rds-my--s': spacing === 's',
    'rds-my--m': spacing === 'm',
    'rds-my--l': spacing === 'l',
    'rds-my--xl': spacing === 'xl',
    'rds-my--xxl': spacing === 'xxl',
    'rds-my--xxxl': spacing === 'xxxl',
    'rds-divider--has-text-left-aligned': text && textAlign === 'left',
    'rds-divider--has-text-center-aligned': text && textAlign === 'center',
    'rds-divider--has-text-right-aligned': text && textAlign === 'right',
    'rds-divider--light': skin === 'light',
    'rds-divider--dark': skin === 'dark'
  }, className);
  return text ? /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassNames,
    role: "separator"
  }, rest), /*#__PURE__*/_react.default.createElement("span", {
    className: 'rds-divider__text'
  }, text)) : /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassNames,
    role: "separator"
  }, rest));
};

Divider.propTypes = propTypes;
Divider.defaultProps = defaultProps;
var _default = Divider;
exports.default = _default;